import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import { transition } from '../style-settings'

export const useFilterOpenButtonStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      appearance: 'none',
      border: 0,
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box',
      flexShrink: 0,
      width: 40,
      height: 40,
      minWidth: 40,
      minHeight: 40,
      maxWidth: 40,
      maxHeight: 40,
      padding: 0,
      backgroundColor: theme.palette.common.white,
      borderRadius: theme.shape.borderRadius * 2,
      color: theme.palette.text.secondary,
      lineHeight: 1,
      transition: transition,
      overflow: 'hidden',
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
        color: theme.palette.primary.main,
      },
      '&:focus-visible': {
        outline: 'none',
        boxShadow: `0 0 0 3px ${theme.palette.primary.main}20`,
      },
      '& .MuiSvgIcon-root': {
        fontSize: '1.25rem',
        display: 'block',
      },
    },
  })
)
